export default __webpack_public_path__ + "static/media/restart.9d2a0e85.svg";